<template>
  <b-container>
    <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
      <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>

      <b-row class="py-3">
        <b-col>
          <h2>Z-Report</h2>
        </b-col>
      </b-row>

      <b-row class="py-2">
        <b-col md="1" cols="2" class="pt-2 pl-4">Date</b-col>
        <b-col cols="10"><b-form-datepicker v-model="date"></b-form-datepicker></b-col>
      </b-row>
      <b-row class="py-2">
        <b-col md="1" cols="3"><b-button variant="light" @click="clearFilters">Clear</b-button></b-col>
        <b-col md="3" cols="6"><b-button variant="dark" @click="runZReport()">Run Report</b-button></b-col>
      </b-row>

      <h4 class="pt-3">Staff Summary</h4>
      <b-table
       :items="staff_results"
       :fields="staff_fields"
      >
        <template #cell(discount_total)="data">
          {{ data.item.discount_total | toCurrency }}
        </template>

        <template #cell(tip_total)="data">
          {{ data.item.tip_total | toCurrency }}
        </template>

        <template #cell(tax_total)="data">
          {{ data.item.tax_total | toCurrency }}
        </template>

        <template #cell(sales_total)="data">
          {{ data.item.sales_total | toCurrency }}
        </template>

        <template v-slot:custom-foot>
          <b-tr class="table-footer">
            <b-td>{{ staff_totals.staff_name }}</b-td>
            <b-td>{{ staff_totals.order_count }}</b-td>
            <b-td>{{ staff_totals.discount_total | toCurrency }}</b-td>
            <b-td>{{ staff_totals.tip_total | toCurrency }}</b-td>
            <b-td>{{ staff_totals.tax_total | toCurrency }}</b-td>
            <b-td>{{ staff_totals.sales_total | toCurrency }}</b-td>
          </b-tr>
        </template>
      </b-table>

      <h4 class="pt-3">Order Summary</h4>
      <b-table
       :items="order_results"
       :fields="order_fields">
        <template #cell(sales_total)="data">
          {{ data.item.sales_total | toCurrency }}
        </template>
        <template v-slot:custom-foot>
          <b-tr class="table-footer">
            <b-td>{{ order_totals.how_ordered }}</b-td>
            <b-td>{{ order_totals.order_count }}</b-td>
            <b-td>{{ order_totals.sales_total | toCurrency }}</b-td>
          </b-tr>
        </template>
      </b-table>

      <h4 class="pt-3">Sales by Category</h4>
      <b-table
       :items="catitem_results"
       :fields="catitem_fields">
        <template #cell(net_sales)="data">
          {{ data.item.net_sales | toCurrency }}
        </template>
        <template v-slot:custom-foot>
          <b-tr class="table-footer">
            <b-td>{{ catitem_totals.category_name }}</b-td>
            <b-td>{{ catitem_totals.num_items }}</b-td>
            <b-td>{{ catitem_totals.net_sales | toCurrency }}</b-td>
          </b-tr>
        </template>
      </b-table>

      <h4 class="pt-3">Payment Types</h4>
      <b-table
       :items="payment_results"
       :fields="payment_fields">
        <template #cell(net_sales)="data">
          {{ data.item.sales_total | toCurrency }}
        </template>
        <template v-slot:custom-foot>
          <b-tr class="table-footer">
            <b-td>{{ pay_totals.payment_method }}</b-td>
            <b-td>{{ pay_totals.sales_total | toCurrency }}</b-td>
          </b-tr>
        </template>
      </b-table>

    </b-overlay>
  </b-container>
</template>


<script>
export default {
  name: "ZReport",
  data() {
    return {
      showoverlay: false,
      date: '',
      staff_results: [],
      staff_totals: [],
      staff_fields: [
          'staff_name',
          'order_count',
          'discount_total',
          'tip_total',
          'tax_total',
          'sales_total'
      ],
      order_results: [],
      order_totals: [],
      order_fields: [
          'how_ordered',
          'order_count',
          'sales_total'
      ],
      catitem_results: [],
      catitem_totals: [],
      catitem_fields: [
          'category_name',
          'num_items',
          'net_sales'
      ],
      payment_results: [],
      pay_totals: [],
      payment_fields: [
          'payment_method',
          'sales_total',
      ],
    };
  },

  computed: {
    datefilter: function() {
      if (this.date) {
        return '?date='+this.date;
      } else {
        return '';
      }
    },
  },

  methods: {
    async runZReport() {
      this.showoverlay = true;
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("reports/z-report"+this.datefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      this.staff_results = await data.staff_orders;
      this.staff_totals = data.staff_totals[0];
      this.order_results = data.how_ordered;
      this.order_totals = data.how_totals[0];
      this.catitem_results = data.items_by_category;
      this.catitem_totals = data.catitem_totals[0];
      this.payment_results = data.payment_methods;
      this.pay_totals = data.pay_totals[0];
      this.showoverlay = false;
    },

    clearFilters() {
      this.date = '';
    },
  },

};
</script>
<style>
  .overspin .spinner-border {
    visibility: hidden;
  }



  .table-footer {
    font-size: 110%;
    font-weight: bold;
  }

</style>
